<template>
  <div id="lb-get-product-mail" class="modal fade" tabindex="-1">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form id="form-instock-mail">
          <div class="modal-header">
            <img src="https://static.tpx.tw/sff/pazzo/static/img/ppp.svg" />
          </div>
          <div class="modal-body">
            <input
              v-model.trim="$v.usermail.$model"
              type="email"
              name="mail"
              placeholder="請輸入E-mail"
              class="form-control"
            />
            <div v-if="!$v.usermail.required" class="error">Field is required</div>
            <div v-if="!$v.usermail.OnlyDigits" class="error">請輸入有效Email</div>
            <p class="mt-3 mb-1">提醒您</p>
            <p class="">此貨到通知不提供商品保留功能</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn" @click.prevent="getNotice">送出</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import { required, helpers } from 'vuelidate/lib/validators';
import axios from 'axios';

const OnlyDigits = helpers.regex(
  'onlyDigits',
  /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/,
);
Vue.use(Vuelidate);

export default {
  name: 'ProductNotice',
  props: ['custommarketid'],
  data() {
    return {
      usermail: '',
    };
  },
  validations: {
    usermail: {
      required,
      OnlyDigits,
    },
  },
  methods: {
    getNotice() {
      if (!this.$v.$invalid) {
        axios
          .post(API_URL.IN_STOCK_EMAIL, {
            CustomMarketID: this.custommarketid,
            Email: this.usermail,
          })
          .then((res) => {
            if (res.data.Code === 200) {
              $('#lb-get-product-mail').modal('hide');
              parent.pazzo.alert('到貨通知索取成功<br>謝謝您：）', '<i class="icon-pazzo"></i>');
            }
          });
      }
    },
  },
};
</script>
